import { createContext, useContext } from "react";
import mainStore from "./mainStore";

import schedulePlanStore from "./schedulePlanStore";
import evaluationStore from "./evaluationStore";


export const store = {
  mainStore: new mainStore(),
  schedulePlanStore: new schedulePlanStore(),
  evaluationStore: new evaluationStore(),
};

export const StoreContext = createContext(store);

export function useStore() {
  return useContext(StoreContext);
}
